import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  visibility = new BehaviorSubject(false);
  spinnerVisibility = new BehaviorSubject(false);

  constructor() {}

  show() {
    setTimeout(() => {
      this.visibility.next(true);
    });
  }

  hide() {
    setTimeout(() => {
      this.visibility.next(false);
    });
  }

  showSpinner() {
    setTimeout(() => {
      this.spinnerVisibility.next(true);
    });
  }

  hideSpinner() {
    setTimeout(() => {
      this.spinnerVisibility.next(false);
    }, 500);
  }
}
